import React, { useRef, useEffect } from 'react';
import { useUpdateEffect } from 'ahooks';
import Marker from './Marker';
import { registerEventGeometry } from '../events';
import useProps from "../_util/useProps";

export default function(props) {
    const {data, property, style, label} = props;
    const featureRef = useRef();
    const { featureLayer } = useProps();

    useEffect(() => {
        let feature = new Marker({
            geometry: data,
            style,
            properties: property,
            label: label,
        });

        // 注册事件
        registerEventGeometry(feature, props);

        featureLayer.entities.add(feature);

        featureRef.current = feature;

        return () => {
            featureLayer.entities.remove(feature);
        };
    }, []);

    useUpdateEffect(() => {
        featureRef.current.setGeometry(data);
    }, [JSON.stringify(data)]);

    useUpdateEffect(() => {
        featureRef.current.setProperties(property);
    }, [JSON.stringify(property)]);

    useUpdateEffect(() => {
        featureRef.current.setStyle(style);
    }, [JSON.stringify(style)]);

    useUpdateEffect(() => {
        featureRef.current.setLabel(label);
    }, [JSON.stringify(label)]);

    return <></>;
}
